function IconStore() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" className="checkout-shipping-icon">
      <path
        fill="currentColor"
        d="M4 6h16l-1.5 3H5.5L4 6zm1 5h14v9H5v-9zm3 2v5h2v-5H8zm6 0v5h2v-5h-2z"
      />
    </svg>
  );
}

function IconLocker() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" className="checkout-shipping-icon">
      <path
        fill="currentColor"
        d="M4 4h16v16H4V4zm3 3v10h3V7H7zm5 0v10h3V7h-3zm5 0v10h3V7h-3z"
      />
    </svg>
  );
}

function IconTruck() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" className="checkout-shipping-icon">
      <path
        fill="currentColor"
        d="M3 6h11v8H3V6zm12 2h4l2 3v3h-6V8zM6.5 17a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm10 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z"
      />
    </svg>
  );
}

const GROUPS = [
  {
    id: "pickup",
    labelKey: "groupPickup",
    Icon: IconStore,
    methods: ["pickup"],
  },
  {
    id: "locker",
    labelKey: "groupLocker",
    Icon: IconLocker,
    methods: ["foxpostLocker", "glsLocker"],
  },
  {
    id: "home",
    labelKey: "groupHome",
    Icon: IconTruck,
    methods: ["foxpostHome", "glsHome"],
  },
];

function formatFee(fee, freeLabel) {
  if (fee <= 0) return freeLabel;
  return new Intl.NumberFormat("hu-HU", {
    style: "currency",
    currency: "HUF",
    maximumFractionDigits: 0,
  }).format(fee);
}

function CheckoutShippingStep({ shop, t, shippingMethod, onSelect }) {
  return (
    <div className="checkout-shipping-groups">
      {GROUPS.map((group) => {
        const enabled = group.methods.filter((id) => shop?.shipping?.[id]?.enabled);
        if (!enabled.length) return null;

        const Icon = group.Icon;

        return (
          <section key={group.id} className="checkout-shipping-group">
            <h4 className="checkout-shipping-group-title">{t[group.labelKey]}</h4>
            <div className="checkout-shipping-options">
              {enabled.map((id) => {
                const fee = shop.shipping[id].priceHuf;
                const isSelected = shippingMethod === id;
                return (
                  <label
                    key={id}
                    className={`checkout-shipping-option${isSelected ? " is-selected" : ""}`}
                  >
                    <input
                      type="radio"
                      name="shippingMethod"
                      value={id}
                      checked={isSelected}
                      onChange={() => onSelect(id)}
                    />
                    <Icon />
                    <span className="checkout-shipping-option-copy">
                      <span className="checkout-shipping-option-name">{t.methods[id]}</span>
                      <span className="checkout-shipping-option-fee">
                        {formatFee(fee, t.freeShipping)}
                      </span>
                    </span>
                  </label>
                );
              })}
            </div>
          </section>
        );
      })}
    </div>
  );
}

export default CheckoutShippingStep;
